













import { Toast } from "vant";
import { Component, Vue } from "vue-property-decorator";
import { getPhoneCode } from "@/req/login"

import NavBar from "./header.vue"
@Component({
  components: {
    NavBar
  }
})
export default class Logout extends Vue {
   // 表单效验规则
   public loginFormRules = {
            phone: [
              { required: true},
              { pattern: /^[\d]{6,11}$/ }
            ],
          }
  public passwordShow = false;
  public btnBgc = false;
  public formLogin = {
          phone: '',
        }
  public async onSubmit() {
    const obj = {
      phone: this.formLogin.phone,
      event: 3
    }
    const res = await getPhoneCode(obj);
    if (res.code === 200) {
      this.$router.push(
        { name: 'code', params: { phone: this.formLogin.phone, flag: "amend" }}
      );
    } else {
      Toast(res.msg);
    }
  }
  public onChange(val) {
    if (val === "") {
        this.btnBgc = false;
    } else {
        this.btnBgc = true;
    }
  }

}
